module.exports = __webpack_public_path__ + "static/media/Technologyicon04@2x.9c9c2f5f.png";